import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StrlimitPipe } from './pipes/strlimit.pipe';
import { UtcToLocalPipe } from './pipes/utc-to-local.pipe';
import { GroupByPipe } from './pipes/group-by.pipe';
import { OrderModule } from 'ngx-order-pipe';
import { DisabledWorkflowElementDirective } from './directives/disabled-workflow-element.directive';
import { StRatioDirective } from './directives/st-ratio.directive';
import { DisabledButtonDirective } from './directives/disabled-button.directive';
import { DisabledWorkflowRevievPublishElementDirective } from './directives/disabled-workflow-reviev-publish-element.directive';
import { DisabledWorkflowDashboardElementsDirective } from './directives/disabled-workflow-dashboard-elements.directive';
import { DisabledIndividualElementDirective } from './directives/disabled-individual-element.directive';
import { DisabledElementDirective } from './directives/disabled-element.directive';
import { DisabledDIEventsElementDirective } from './directives/disabled-dievents-element.directive';
import { OrderByPipe } from './pipes/order-by.pipe';
import { DndDirective } from './directives/dnd.directive';
import { RemoveEscapecharDirective } from './directives/remove-escapechar.directive';
import { FormatPhoneDirective } from './directives/format-phone.directive';
import { FormatDateDirective } from './directives/format-date.directive';
import { DigitsOnlyDirective } from './directives/digits-only.directive';
import { DigitsOnlyWithHyphenDirective } from './directives/digits-only-with-hyphen.directive';
import { ValidNumberDirective } from './directives/valid-number.directive';
import { NgSessionStorage, NgLocalStorage } from 'core/utils/ng-storage.service';
import { DashboardfilterPipe } from './pipes/dashboardfilter.pipe';
import { DigitsWithHypenDotDirective } from './directives/digits-with-hypen-dot.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { CoOrdinatesDirective } from './directives/co-ordinates.directive';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './components/confirmation-dialog/confirmation-dialog.service';
import { MessageService } from './services/message.service';
import { PrgrmRemoveEscapeCharDirective } from './directives/prgrm-remove-escape-char.directive';
import { PercentageDirective } from './directives/percentage.directive';
import { AlphanumericDashDirective } from './directives/alphanumeric-dash.directive';
import { UrlFormatDirective } from './directives/domain-url.directive';
import { KeysPipe } from './pipes/keys.pipe';
import { ChecklistDirective } from './directives/checklist.directive';
@NgModule({
  declarations: [
    StrlimitPipe,
    UtcToLocalPipe,
    GroupByPipe,
    DisabledWorkflowElementDirective,
    StRatioDirective,
    DisabledButtonDirective,
    DisabledWorkflowRevievPublishElementDirective,
    DisabledWorkflowDashboardElementsDirective,
    DisabledIndividualElementDirective,
    DisabledElementDirective,
    DisabledDIEventsElementDirective,
    OrderByPipe,
    DndDirective,
    RemoveEscapecharDirective,
    FormatPhoneDirective,
    FormatDateDirective,
    DigitsOnlyDirective,
    DigitsOnlyWithHyphenDirective,
    ValidNumberDirective,
    DashboardfilterPipe,
    DigitsWithHypenDotDirective,
    CoOrdinatesDirective,
    ConfirmationDialogComponent,
    PrgrmRemoveEscapeCharDirective,
    PercentageDirective,
    AlphanumericDashDirective,
    UrlFormatDirective,
    KeysPipe,
    ChecklistDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgbModule,
    FontAwesomeModule,
    OrderModule,
    MatDialogModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    StrlimitPipe,
    UtcToLocalPipe,
    GroupByPipe,
    DisabledWorkflowElementDirective,
    DisabledWorkflowRevievPublishElementDirective,
    DisabledWorkflowDashboardElementsDirective,
    StRatioDirective,
    DisabledButtonDirective,
    OrderByPipe,
    RemoveEscapecharDirective,
    FormatPhoneDirective,
    DigitsOnlyDirective,
    DigitsOnlyWithHyphenDirective,
    ValidNumberDirective,
    DashboardfilterPipe,
    DigitsWithHypenDotDirective,
    CoOrdinatesDirective,
    PercentageDirective,
    AlphanumericDashDirective,
    UrlFormatDirective,
    KeysPipe,
    ChecklistDirective
  ],
  providers: [
    OrderByPipe,
    NgSessionStorage,
    NgLocalStorage,
    MessageService
  ]
})
export class SharedModule { }
